import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone } = FiIcons;

const CareersWidget = () => {
  useEffect(() => {
    const scriptUrl = 'https://day2day.care/careers-embed.js';
    if (document.querySelector(`script[src="${scriptUrl}"]`)) return;

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <iframe
      src="https://day2day.care/careers/odara-care/widget?accent=074470&columns=2"
      title="KCG current vacancies and applications"
      loading="lazy"
      height="600"
      className="block w-full h-[600px] border-0"
    />
  );
};

const Careers = () => (
  <>
    <Helmet>
      <title>Careers at KCG | Kabod Care Group</title>
      <meta name="description" content="Explore current care jobs with KCG, apply through our careers portal, or contact our team about opportunities." />
      <link rel="canonical" href="https://kcg.care/careers" />
    </Helmet>
    <section className="bg-gradient-to-br from-primary-900 to-secondary-900 py-24 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl lg:text-5xl font-bold mb-6">Careers at KCG</h1>
        <p className="text-xl text-primary-100 leading-relaxed">Interested in supporting people in their own homes? We would be glad to hear from you.</p>
      </div>
    </section>
    <section className="py-16 bg-primary-50" aria-labelledby="current-vacancies-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-sm font-semibold uppercase tracking-wider text-primary-900 mb-3">Work with KCG</p>
        <h2 id="current-vacancies-heading" className="text-3xl font-bold text-gray-900 mb-4">Current vacancies</h2>
        <p className="text-lg text-gray-600 mb-3">Browse roles and apply through our careers portal.</p>
        <p className="text-sm text-gray-600 mb-8">The portal may still show Odara Care, our former name, while its branding is updated.</p>
        <div className="bg-white rounded-2xl border border-primary-100 shadow-lg overflow-hidden">
          <CareersWidget />
        </div>
        <p className="mt-4 text-sm text-gray-600">
          If the vacancies do not appear, <a href="https://day2day.care/careers/odara-care" target="_blank" rel="noopener noreferrer" className="font-semibold text-primary-900 underline underline-offset-2">open the careers portal in a new tab</a>.
        </p>
      </div>
    </section>
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-5">Ask about opportunities</h2>
        <p className="text-lg text-gray-600 mb-8">Email our team to ask which roles are currently open, where they are based, and how to apply. Our existing careers address remains in use during the KCG transition.</p>
        <div className="grid sm:grid-cols-2 gap-6">
          <a href="mailto:careers@odaracare.org.uk?subject=Careers%20enquiry" className="rounded-2xl border border-primary-100 bg-primary-50 p-8 hover:shadow-lg transition-shadow">
            <SafeIcon icon={FiMail} className="w-8 h-8 text-primary-900 mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-2">Email careers</h3>
            <p className="text-primary-900 font-semibold break-all">careers@odaracare.org.uk</p>
          </a>
          <a href="tel:03333394077" className="rounded-2xl border border-primary-100 bg-primary-50 p-8 hover:shadow-lg transition-shadow">
            <SafeIcon icon={FiPhone} className="w-8 h-8 text-primary-900 mb-4" />
            <h3 className="text-xl font-bold text-gray-900 mb-2">Call us</h3>
            <p className="text-primary-900 font-semibold">03333 394 077</p>
          </a>
        </div>
      </div>
    </section>
  </>
);

export default Careers;
